import styled from 'styled-components';

const PSmall = styled.div`
  font-family:'Montserrat';
  font-size: 13px;
  font-weight:400;
  line-height:1.8em;
  margin: 0.25em 0;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;

  @media (min-width: 992px) {
    font-size: 13px;
 }
`;

export default PSmall;